let t = "undefined" !== typeof globalThis ? globalThis : "undefined" !== typeof self ? self : global;
(function (i, e, s) {
    let Timepicker = function (e, s) {
        (this || t).widget = "";
        (this || t).$element = i(e);
        (this || t).defaultTime = s.defaultTime;
        (this || t).disableFocus = s.disableFocus;
        (this || t).disableMousewheel = s.disableMousewheel;
        (this || t).isOpen = s.isOpen;
        (this || t).minuteStep = s.minuteStep;
        (this || t).modalBackdrop = s.modalBackdrop;
        (this || t).orientation = s.orientation;
        (this || t).secondStep = s.secondStep;
        (this || t).snapToStep = s.snapToStep;
        (this || t).showInputs = s.showInputs;
        (this || t).showMeridian = s.showMeridian;
        (this || t).showSeconds = s.showSeconds;
        (this || t).template = s.template;
        (this || t).appendWidgetTo = s.appendWidgetTo;
        (this || t).showWidgetOnAddonClick = s.showWidgetOnAddonClick;
        (this || t).icons = s.icons;
        (this || t).maxHours = s.maxHours;
        (this || t).explicitMode = s.explicitMode;
        (this || t).handleDocumentClick = function (t) {
            let i = t.data.scope;
            i.$element.parent().find(t.target).length || i.$widget.is(t.target) || i.$widget.find(t.target).length || i.hideWidget()
        };
        this._init()
    };
    Timepicker.prototype = {
        constructor: Timepicker, _init: function () {
            let e = this || t;
            if ((this || t).showWidgetOnAddonClick && (this || t).$element.parent().hasClass("input-group") && (this || t).$element.parent().hasClass("bootstrap-timepicker")) {
                (this || t).$element.parent(".input-group.bootstrap-timepicker").find(".input-group-addon").on({"click.timepicker": i.proxy((this || t).showWidget, this || t)});
                (this || t).$element.on({
                    "focus.timepicker": i.proxy((this || t).highlightUnit, this || t),
                    "click.timepicker": i.proxy((this || t).highlightUnit, this || t),
                    "keydown.timepicker": i.proxy((this || t).elementKeydown, this || t),
                    "blur.timepicker": i.proxy((this || t).blurElement, this || t),
                    "mousewheel.timepicker DOMMouseScroll.timepicker": i.proxy((this || t).mousewheel, this || t)
                })
            } else (this || t).template ? (this || t).$element.on({
                // "focus.timepicker": i.proxy((this || t).showWidget, this || t), 
                // "click.timepicker": i.proxy((this || t).showWidget, this || t),
                "blur.timepicker": i.proxy((this || t).blurElement, this || t),
                "mousewheel.timepicker DOMMouseScroll.timepicker": i.proxy((this || t).mousewheel, this || t)
            }) : (this || t).$element.on({
                "focus.timepicker": i.proxy((this || t).highlightUnit, this || t),
                "click.timepicker": i.proxy((this || t).highlightUnit, this || t),
                "keydown.timepicker": i.proxy((this || t).elementKeydown, this || t),
                "blur.timepicker": i.proxy((this || t).blurElement, this || t),
                "mousewheel.timepicker DOMMouseScroll.timepicker": i.proxy((this || t).mousewheel, this || t)
            });
            false !== (this || t).template ? (this || t).$widget = i(this.getTemplate()).on("click", i.proxy((this || t).widgetClick, this || t)) : (this || t).$widget = false;
            (this || t).showInputs && false !== (this || t).$widget && (this || t).$widget.find("input").each((function () {
                i(this || t).on({
                    "click.timepicker": function () {
                        i(this || t).select()
                    }, "keydown.timepicker": i.proxy(e.widgetKeydown, e), "keyup.timepicker": i.proxy(e.widgetKeyup, e)
                })
            }));
            this.setDefaultTime((this || t).defaultTime)
        }, blurElement: function () {
            (this || t).highlightedUnit = null;
            this.updateFromElementVal()
        }, clear: function () {
            (this || t).hour = "";
            (this || t).minute = "";
            (this || t).second = "";
            (this || t).meridian = "";
            (this || t).$element.val("")
        }, decrementHour: function () {
            if ((this || t).showMeridian) if (1 === (this || t).hour) (this || t).hour = 12; else {
                if (12 === (this || t).hour) {
                    (this || t).hour--;
                    return this.toggleMeridian()
                }
                if (0 === (this || t).hour || '00' === String((this || t).hour)) {
                    (this || t).hour = 11;
                    return this.toggleMeridian()
                }
                (this || t).hour--
            } else (this || t).hour <= 0 ? (this || t).hour = (this || t).maxHours - 1 : (this || t).hour--
            if (this.hour < 10) {this.hour = "0" + this.hour;}
        }, decrementMinute: function (i) {
            let e;
            e = i ? (this || t).minute - i : (this || t).minute - (this || t).minuteStep;
            if (e < 0) {
                this.decrementHour();
                (this || t).minute = e + 60
            } else (this || t).minute = e
        }, decrementSecond: function () {
            let i = (this || t).second - (this || t).secondStep;
            if (i < 0) {
                this.decrementMinute(true);
                (this || t).second = i + 60
            } else (this || t).second = i
        }, elementKeydown: function (i) {
            switch (i.which) {
                case 9:
                    if (i.shiftKey) {
                        if ("hour" === (this || t).highlightedUnit) {
                            this.hideWidget();
                            break
                        }
                        this.highlightPrevUnit()
                    } else {
                        if ((this || t).showMeridian && "meridian" === (this || t).highlightedUnit || (this || t).showSeconds && "second" === (this || t).highlightedUnit || !(this || t).showMeridian && !(this || t).showSeconds && "minute" === (this || t).highlightedUnit) {
                            this.hideWidget();
                            break
                        }
                        this.highlightNextUnit()
                    }
                    i.preventDefault();
                    this.updateFromElementVal();
                    break;
                case 27:
                    this.updateFromElementVal();
                    break;
                case 37:
                    i.preventDefault();
                    this.highlightPrevUnit();
                    this.updateFromElementVal();
                    break;
                case 38:
                    i.preventDefault();
                    switch ((this || t).highlightedUnit) {
                        case"hour":
                            this.incrementHour();
                            this.highlightHour();
                            break;
                        case"minute":
                            this.incrementMinute();
                            this.highlightMinute();
                            break;
                        case"second":
                            this.incrementSecond();
                            this.highlightSecond();
                            break;
                        case"meridian":
                            this.toggleMeridian();
                            this.highlightMeridian();
                            break
                    }
                    this.update();
                    break;
                case 39:
                    i.preventDefault();
                    this.highlightNextUnit();
                    this.updateFromElementVal();
                    break;
                case 40:
                    i.preventDefault();
                    switch ((this || t).highlightedUnit) {
                        case"hour":
                            this.decrementHour();
                            this.highlightHour();
                            break;
                        case"minute":
                            this.decrementMinute();
                            this.highlightMinute();
                            break;
                        case"second":
                            this.decrementSecond();
                            this.highlightSecond();
                            break;
                        case"meridian":
                            this.toggleMeridian();
                            this.highlightMeridian();
                            break
                    }
                    this.update();
                    break
            }
        }, getCursorPosition: function () {
            let i = (this || t).$element.get(0);
            if ("selectionStart" in i) return i.selectionStart;
            if (s.selection) {
                i.focus();
                let e = s.selection.createRange(), h = s.selection.createRange().text.length;
                e.moveStart("character", -i.value.length);
                return e.text.length - h
            }
        }, getTemplate: function () {
            let i, e, s, h, n, o;
            if ((this || t).showInputs) {
                e = '<input type="text" class="bootstrap-timepicker-hour" maxlength="2"/>';
                s = '<input type="text" class="bootstrap-timepicker-minute" maxlength="2"/>';
                h = '<input type="text" class="bootstrap-timepicker-second" maxlength="2"/>';
                n = '<input type="text" class="bootstrap-timepicker-meridian" maxlength="2"/>'
            } else {
                e = '<span class="bootstrap-timepicker-hour"></span>';
                s = '<span class="bootstrap-timepicker-minute"></span>';
                h = '<span class="bootstrap-timepicker-second"></span>';
                n = '<span class="bootstrap-timepicker-meridian"></span>'
            }
            o = "<table>" + "<tr>" + '<td><a href="#" data-action="incrementHour"><span class="' + (this || t).icons.up + '"></span></a></td>' + '<td class="separator">&nbsp;</td>' + '<td><a href="#" data-action="incrementMinute"><span class="' + (this || t).icons.up + '"></span></a></td>' + ((this || t).showSeconds ? '<td class="separator">&nbsp;</td>' + '<td><a href="#" data-action="incrementSecond"><span class="' + (this || t).icons.up + '"></span></a></td>' : "") + ((this || t).showMeridian ? '<td class="separator">&nbsp;</td>' + '<td class="meridian-column"><a href="#" data-action="toggleMeridian"><span class="' + (this || t).icons.up + '"></span></a></td>' : "") + "</tr>" + "<tr>" + "<td>" + e + "</td> " + '<td class="separator">:</td>' + "<td>" + s + "</td> " + ((this || t).showSeconds ? '<td class="separator">:</td>' + "<td>" + h + "</td>" : "") + ((this || t).showMeridian ? '<td class="separator">&nbsp;</td>' + "<td>" + n + "</td>" : "") + "</tr>" + "<tr>" + '<td><a href="#" data-action="decrementHour"><span class="' + (this || t).icons.down + '"></span></a></td>' + '<td class="separator"></td>' + '<td><a href="#" data-action="decrementMinute"><span class="' + (this || t).icons.down + '"></span></a></td>' + ((this || t).showSeconds ? '<td class="separator">&nbsp;</td>' + '<td><a href="#" data-action="decrementSecond"><span class="' + (this || t).icons.down + '"></span></a></td>' : "") + ((this || t).showMeridian ? '<td class="separator">&nbsp;</td>' + '<td><a href="#" data-action="toggleMeridian"><span class="' + (this || t).icons.down + '"></span></a></td>' : "") + "</tr>" + "</table>";
            switch ((this || t).template) {
                case"modal":
                    i = '<div class="bootstrap-timepicker-widget position-absolute card-border rounded-2 shadow-none z-999 modal hide fade in" data-backdrop="' + ((this || t).modalBackdrop ? "true" : "false") + '">' + '<div class="modal-header">' + '<a href="#" class="close" data-dismiss="modal">&times;</a>' + "<h3>Pick a Time</h3>" + "</div>" + '<div class="modal-content bg-card">' + o + "</div>" + '<div class="modal-footer">' + '<a href="#" class="btn btn-primary" data-dismiss="modal">OK</a>' + "</div>" + "</div>";
                    break;
                case"dropdown":
                    i = '<div class="bootstrap-timepicker-widget position-absolute card-border rounded-2 shadow-none z-999 dropdown-menu">' + o + "</div>";
                    break
            }
            return i
        }, getTime: function () {
            return "" === (this || t).hour ? "" : (this || t).hour + ":" + (1 === (this || t).minute.toString().length ? "0" + (this || t).minute : (this || t).minute) + ((this || t).showSeconds ? ":" + (1 === (this || t).second.toString().length ? "0" + (this || t).second : (this || t).second) : "") + ((this || t).showMeridian ? " " + (this || t).meridian : "")
        }, hideWidget: function () {
            if (false !== (this || t).isOpen) {
                (this || t).$element.trigger({
                    type: "hide.timepicker",
                    time: {
                        value: this.getTime(),
                        hours: (this || t).hour,
                        minutes: (this || t).minute,
                        seconds: (this || t).second,
                        meridian: (this || t).meridian
                    }
                });
                "modal" === (this || t).template && (this || t).$widget.modal ? (this || t).$widget.modal("hide") : (this || t).$widget.removeClass("open");
                i(s).off("mousedown.timepicker, touchend.timepicker", (this || t).handleDocumentClick);
                (this || t).isOpen = false;
                (this || t).$widget.detach()
            }
        }, highlightUnit: function () {
            (this || t).position = this.getCursorPosition();
            (this || t).position >= 0 && (this || t).position <= 2 ? this.highlightHour() : (this || t).position >= 3 && (this || t).position <= 5 ? this.highlightMinute() : (this || t).position >= 6 && (this || t).position <= 8 ? (this || t).showSeconds ? this.highlightSecond() : this.highlightMeridian() : (this || t).position >= 9 && (this || t).position <= 11 && this.highlightMeridian()
        }, highlightNextUnit: function () {
            switch ((this || t).highlightedUnit) {
                case"hour":
                    this.highlightMinute();
                    break;
                case"minute":
                    (this || t).showSeconds ? this.highlightSecond() : (this || t).showMeridian ? this.highlightMeridian() : this.highlightHour();
                    break;
                case"second":
                    (this || t).showMeridian ? this.highlightMeridian() : this.highlightHour();
                    break;
                case"meridian":
                    this.highlightHour();
                    break
            }
        }, highlightPrevUnit: function () {
            switch ((this || t).highlightedUnit) {
                case"hour":
                    (this || t).showMeridian ? this.highlightMeridian() : (this || t).showSeconds ? this.highlightSecond() : this.highlightMinute();
                    break;
                case"minute":
                    this.highlightHour();
                    break;
                case"second":
                    this.highlightMinute();
                    break;
                case"meridian":
                    (this || t).showSeconds ? this.highlightSecond() : this.highlightMinute();
                    break
            }
        }, highlightHour: function () {
            let i = (this || t).$element.get(0), e = this || t;
            (this || t).highlightedUnit = "hour";
            i.setSelectionRange && setTimeout((function () {
                e.hour < 10 ? i.setSelectionRange(0, 1) : i.setSelectionRange(0, 2)
            }), 0)
        }, highlightMinute: function () {
            let i = (this || t).$element.get(0), e = this || t;
            (this || t).highlightedUnit = "minute";
            i.setSelectionRange && setTimeout((function () {
                e.hour < 10 ? i.setSelectionRange(2, 4) : i.setSelectionRange(3, 5)
            }), 0)
        }, highlightSecond: function () {
            let i = (this || t).$element.get(0), e = this || t;
            (this || t).highlightedUnit = "second";
            i.setSelectionRange && setTimeout((function () {
                e.hour < 10 ? i.setSelectionRange(5, 7) : i.setSelectionRange(6, 8)
            }), 0)
        }, highlightMeridian: function () {
            let i = (this || t).$element.get(0), e = this || t;
            (this || t).highlightedUnit = "meridian";
            i.setSelectionRange && ((this || t).showSeconds ? setTimeout((function () {
                e.hour < 10 ? i.setSelectionRange(8, 10) : i.setSelectionRange(9, 11)
            }), 0) : setTimeout((function () {
                e.hour < 10 ? i.setSelectionRange(5, 7) : i.setSelectionRange(6, 8)
            }), 0))
        }, incrementHour: function () {
            if ((this || t).showMeridian) {
                if (11 === (this || t).hour) {
                    (this || t).hour++;
                    return this.toggleMeridian()
                }
                12 === (this || t).hour && ((this || t).hour = 0)
            }
            (this || t).hour !== (this || t).maxHours - 1 ? (this || t).hour++ : (this || t).hour = 0
            if (this.hour < 10) {this.hour = "0" + this.hour;}
        }, incrementMinute: function (i) {
            let e;
            e = i ? (this || t).minute + i : (this || t).minute + (this || t).minuteStep - (this || t).minute % (this || t).minuteStep;
            if (e > 59) {
                this.incrementHour();
                (this || t).minute = e - 60
            } else (this || t).minute = e
        }, incrementSecond: function () {
            let i = (this || t).second + (this || t).secondStep - (this || t).second % (this || t).secondStep;
            if (i > 59) {
                this.incrementMinute(true);
                (this || t).second = i - 60
            } else (this || t).second = i
        }, mousewheel: function (e) {
            if (!(this || t).disableMousewheel) {
                e.preventDefault();
                e.stopPropagation();
                let s = e.originalEvent.wheelDelta || -e.originalEvent.detail, h = null;
                "mousewheel" === e.type ? h = -1 * e.originalEvent.wheelDelta : "DOMMouseScroll" === e.type && (h = 40 * e.originalEvent.detail);
                if (h) {
                    e.preventDefault();
                    i(this || t).scrollTop(h + i(this || t).scrollTop())
                }
                switch ((this || t).highlightedUnit) {
                    case"minute":
                        s > 0 ? this.incrementMinute() : this.decrementMinute();
                        this.highlightMinute();
                        break;
                    case"second":
                        s > 0 ? this.incrementSecond() : this.decrementSecond();
                        this.highlightSecond();
                        break;
                    case"meridian":
                        this.toggleMeridian();
                        this.highlightMeridian();
                        break;
                    default:
                        s > 0 ? this.incrementHour() : this.decrementHour();
                        this.highlightHour();
                        break
                }
                return false
            }
        }, changeToNearestStep: function (t, i) {
            return t % i === 0 ? t : Math.round(t % i / i) ? (t + (i - t % i)) % 60 : t - t % i
        }, place: function () {
            if (!(this || t).isInline) {
                let s = (this || t).$widget.outerWidth(), h = (this || t).$widget.outerHeight(), n = 10,
                    o = i(e).width(), a = i(e).height(), r = i(e).scrollTop();
                let d = Number.parseInt((this || t).$element.parents().filter((function () {
                    return "auto" !== i(this || t).css("z-index")
                })).first().css("z-index"), 10) + 10;
                let c = (this || t).component ? (this || t).component.parent().offset() : (this || t).$element.offset();
                let l = (this || t).component ? (this || t).component.outerHeight(true) : (this || t).$element.outerHeight(false);
                let u = (this || t).component ? (this || t).component.outerWidth(true) : (this || t).$element.outerWidth(false);
                let p = c.left, m = c.top;
                (this || t).$widget.removeClass("timepicker-orient-top timepicker-orient-bottom timepicker-orient-right timepicker-orient-left");
                if ("auto" !== (this || t).orientation.x) {
                    (this || t).$widget.addClass("timepicker-orient-" + (this || t).orientation.x);
                    "right" === (this || t).orientation.x && (p -= s - u)
                } else {
                    (this || t).$widget.addClass("timepicker-orient-left");
                    c.left < 0 ? p -= c.left - n : c.left + s > o && (p = o - s - n)
                }
                let g = (this || t).orientation.y, f, w;
                if ("auto" === g) {
                    f = -r + c.top - h;
                    w = r + a - (c.top + l + h);
                    g = Math.max(f, w) === w ? "top" : "bottom"
                }
                (this || t).$widget.addClass("timepicker-orient-" + g);
                "top" === g ? m += l : m -= h + Number.parseInt((this || t).$widget.css("padding-top"), 10);
                (this || t).$widget.css({top: m, left: p, zIndex: d})
            }
        }, remove: function () {
            i("document").off(".timepicker");
            (this || t).$widget && (this || t).$widget.remove();
            delete (this || t).$element.data().timepicker
        }, setDefaultTime: function (i) {
            if ((this || t).$element.val()) this.updateFromElementVal(); else if ("current" === i) {
                let e = new Date, s = e.getHours(), h = e.getMinutes(), n = e.getSeconds(), o = "AM";
                if (0 !== n) {
                    n = Math.ceil(e.getSeconds() / (this || t).secondStep) * (this || t).secondStep;
                    if (60 === n) {
                        h += 1;
                        n = 0
                    }
                }
                if (0 !== h) {
                    h = Math.ceil(e.getMinutes() / (this || t).minuteStep) * (this || t).minuteStep;
                    if (60 === h) {
                        s += 1;
                        h = 0
                    }
                }
                if ((this || t).showMeridian) if (0 === s) s = 12; else if (s >= 12) {
                    s > 12 && (s -= 12);
                    o = "PM"
                } else o = "AM";
                (this || t).hour = s;
                (this || t).minute = h;
                (this || t).second = n;
                (this || t).meridian = o;
                this.update()
            } else if (false === i) {
                (this || t).hour = 0;
                (this || t).minute = 0;
                (this || t).second = 0;
                (this || t).meridian = "AM"
            } else this.setTime(i)
        }, setTime: function (i, e) {
            if (i) {
                let s, h, n, o, a, r;
                if ("object" === typeof i && i.getMonth) {
                    n = i.getHours();
                    o = i.getMinutes();
                    a = i.getSeconds();
                    if ((this || t).showMeridian) {
                        r = "AM";
                        if (n > 12) {
                            r = "PM";
                            n %= 12
                        }
                        12 === n && (r = "PM")
                    }
                } else {
                    s = (/a/i.test(i) ? 1 : 0) + (/p/i.test(i) ? 2 : 0);
                    if (s > 2) {
                        this.clear();
                        return
                    }
                    h = i.replaceAll(/[^0-9\:]/g, "").split(":");
                    n = h[0] ? h[0].toString() : h.toString();
                    if ((this || t).explicitMode && n.length > 2 && n.length % 2 !== 0) {
                        this.clear();
                        return
                    }
                    o = h[1] ? h[1].toString() : "";
                    a = h[2] ? h[2].toString() : "";
                    if (n.length > 4) {
                        a = n.slice(-2);
                        n = n.slice(0, -2)
                    }
                    if (n.length > 2) {
                        o = n.slice(-2);
                        n = n.slice(0, -2)
                    }
                    if (o.length > 2) {
                        a = o.slice(-2);
                        o = o.slice(0, -2)
                    }
                    n = Number.parseInt(n, 10);
                    o = Number.parseInt(o, 10);
                    a = Number.parseInt(a, 10);
                    Number.isNaN(n) && (n = 0);
                    Number.isNaN(o) && (o = 0);
                    Number.isNaN(a) && (a = 0);
                    a > 59 && (a = 59);
                    o > 59 && (o = 59);
                    n >= (this || t).maxHours && (n = (this || t).maxHours - 1);
                    if ((this || t).showMeridian) {
                        if (n > 12) {
                            s = 2;
                            n -= 12
                        }
                        s || (s = 1);
                        0 === n && (n = 12);
                        r = 1 === s ? "AM" : "PM"
                    } else n < 12 && 2 === s ? n += 12 : n >= (this || t).maxHours ? n = (this || t).maxHours - 1 : (n < 0 || 12 === n && 1 === s) && (n = 0)
                }
                (this || t).hour = n < 10 ? "0"+n : n;
                if ((this || t).snapToStep) {
                    (this || t).minute = this.changeToNearestStep(o, (this || t).minuteStep);
                    (this || t).second = this.changeToNearestStep(a, (this || t).secondStep)
                } else {
                    (this || t).minute = o;
                    (this || t).second = a
                }
                (this || t).meridian = r;
                this.update(e)
            } else this.clear()
        }, showWidget: function () {
            if (!(this || t).isOpen && !(this || t).$element.is(":disabled")) {
                (this || t).$widget.appendTo((this || t).appendWidgetTo);
                i(s).on("mousedown.timepicker, touchend.timepicker", {scope: this || t}, (this || t).handleDocumentClick);
                (this || t).$element.trigger({
                    type: "show.timepicker",
                    time: {
                        value: this.getTime(),
                        hours: (this || t).hour,
                        minutes: (this || t).minute,
                        seconds: (this || t).second,
                        meridian: (this || t).meridian
                    }
                });
                this.place();
                (this || t).disableFocus && (this || t).$element.blur();
                "" === (this || t).hour && ((this || t).defaultTime ? this.setDefaultTime((this || t).defaultTime) : this.setTime("0:0:0"));
                "modal" === (this || t).template && (this || t).$widget.modal ? (this || t).$widget.modal("show").on("hidden", i.proxy((this || t).hideWidget, this || t)) : false === (this || t).isOpen && (this || t).$widget.addClass("open");
                (this || t).isOpen = true
            }
        }, toggleMeridian: function () {
            (this || t).meridian = "AM" === (this || t).meridian ? "PM" : "AM"
        }, update: function (i) {
            this.updateElement();
            i || this.updateWidget();
            (this || t).$element.trigger({
                type: "changeTime.timepicker",
                time: {
                    value: this.getTime(),
                    hours: (this || t).hour,
                    minutes: (this || t).minute,
                    seconds: (this || t).second,
                    meridian: (this || t).meridian
                }
            })
        }, updateElement: function () {
            (this || t).$element.val(this.getTime()).change()
        }, updateFromElementVal: function () {
            this.setTime((this || t).$element.val())
        }, updateWidget: function () {
            if (false !== (this || t).$widget) {
                let i = (this || t).hour,
                    e = 1 === (this || t).minute.toString().length ? "0" + (this || t).minute : (this || t).minute,
                    s = 1 === (this || t).second.toString().length ? "0" + (this || t).second : (this || t).second;
                if ((this || t).showInputs) {
                    (this || t).$widget.find("input.bootstrap-timepicker-hour").val(i);
                    (this || t).$widget.find("input.bootstrap-timepicker-minute").val(e);
                    (this || t).showSeconds && (this || t).$widget.find("input.bootstrap-timepicker-second").val(s);
                    (this || t).showMeridian && (this || t).$widget.find("input.bootstrap-timepicker-meridian").val((this || t).meridian)
                } else {
                    (this || t).$widget.find("span.bootstrap-timepicker-hour").text(i);
                    (this || t).$widget.find("span.bootstrap-timepicker-minute").text(e);
                    (this || t).showSeconds && (this || t).$widget.find("span.bootstrap-timepicker-second").text(s);
                    (this || t).showMeridian && (this || t).$widget.find("span.bootstrap-timepicker-meridian").text((this || t).meridian)
                }
            }
        }, updateFromWidgetInputs: function () {
            if (false !== (this || t).$widget) {
                let i = (this || t).$widget.find("input.bootstrap-timepicker-hour").val() + ":" + (this || t).$widget.find("input.bootstrap-timepicker-minute").val() + ((this || t).showSeconds ? ":" + (this || t).$widget.find("input.bootstrap-timepicker-second").val() : "") + ((this || t).showMeridian ? (this || t).$widget.find("input.bootstrap-timepicker-meridian").val() : "");
                this.setTime(i, true)
            }
        }, widgetClick: function (t) {
            t.stopPropagation();
            t.preventDefault();
            let e = i(t.target), s = e.closest("a").data("action");
            s && this[s]();
            this.update();
            e.is("input") && e.get(0).setSelectionRange(0, 2)
        }, widgetKeydown: function (e) {
            let s = i(e.target), h = s.attr("class").replaceAll("bootstrap-timepicker-", "");
            switch (e.which) {
                case 9:
                    if (e.shiftKey) {
                        if ("hour" === h) return this.hideWidget()
                    } else if ((this || t).showMeridian && "meridian" === h || (this || t).showSeconds && "second" === h || !(this || t).showMeridian && !(this || t).showSeconds && "minute" === h) return this.hideWidget();
                    break;
                case 27:
                    this.hideWidget();
                    break;
                case 38:
                    e.preventDefault();
                    switch (h) {
                        case"hour":
                            this.incrementHour();
                            break;
                        case"minute":
                            this.incrementMinute();
                            break;
                        case"second":
                            this.incrementSecond();
                            break;
                        case"meridian":
                            this.toggleMeridian();
                            break
                    }
                    this.setTime(this.getTime());
                    s.get(0).setSelectionRange(0, 2);
                    break;
                case 40:
                    e.preventDefault();
                    switch (h) {
                        case"hour":
                            this.decrementHour();
                            break;
                        case"minute":
                            this.decrementMinute();
                            break;
                        case"second":
                            this.decrementSecond();
                            break;
                        case"meridian":
                            this.toggleMeridian();
                            break
                    }
                    this.setTime(this.getTime());
                    s.get(0).setSelectionRange(0, 2);
                    break
            }
        }, widgetKeyup: function (t) {
            (65 === t.which || 77 === t.which || 80 === t.which || 46 === t.which || 8 === t.which || t.which >= 48 && t.which <= 57 || t.which >= 96 && t.which <= 105) && this.updateFromWidgetInputs()
        }
    };
    i.fn.timepicker = function (e) {
        let s = Array.apply(null, arguments);
        s.shift();
        return this.each((function () {
            let h = i(this || t), n = h.data("timepicker"), o = "object" === typeof e && e;
            n || h.data("timepicker", n = new Timepicker(this || t, i.extend({}, i.fn.timepicker.defaults, o, i(this || t).data())));
            "string" === typeof e && n[e].apply(n, s)
        }))
    };
    i.fn.timepicker.defaults = {
        defaultTime: "current",
        disableFocus: false,
        disableMousewheel: false,
        isOpen: false,
        minuteStep: 15,
        modalBackdrop: false,
        orientation: {x: "auto", y: "auto"},
        secondStep: 15,
        snapToStep: false,
        showSeconds: false,
        showInputs: true,
        showMeridian: true,
        template: "dropdown",
        appendWidgetTo: "body",
        showWidgetOnAddonClick: true,
        icons: {up: "glyphicon glyphicon-chevron-up", down: "glyphicon glyphicon-chevron-down"},
        maxHours: 24,
        explicitMode: false
    };
    i.fn.timepicker.Constructor = Timepicker;
    i(s).on("focus.timepicker.data-api click.timepicker.data-api", '[data-provide="timepicker"]', (function (e) {
        let s = i(this || t);
        if (!s.data("timepicker")) {
            e.preventDefault();
            s.timepicker()
        }
    }))
})(jQuery, globalThis, document);
const i = {};
export default i;
